import { useState, useEffect } from 'react';
import axios from 'axios';

// Custom hook to fetch and manage translations
const useTranslations = () => {
    const [trans, setTrans] = useState({});
    // Function to initialize translations
    const initTranslations = () => {
        const locale = window.config.locale;
        const params = {
            filename: 'recorder',
        };
        axios
            .post(`/api/translate/${locale}`, params)
            .then((response) => {
                setTrans(response.data.data.trans);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    };
    // Run translation initialization when component mounts
    useEffect(() => {
        initTranslations();
    }, []); // Runs once when the component mounts

    return { trans };
};

export default useTranslations;
